import React from 'react';

const RightArrow = ({
                        color = 'currentColor',
                        size = 12,
                        className = '',
                        ...props
                    }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
    );
};

export default RightArrow;